module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_library.js
// module id = 828
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 16